import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "value"]


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSelect',
  props: {
    id: {},
    modelValue: {}
  },
  emits: [
	'update:modelValue',
],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const optionSelected = (e) => {
	emit('update:modelValue', e.target.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("select", {
    id: _ctx.id,
    value: _ctx.modelValue,
    onChange: optionSelected
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})